
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Alarm_code } from '../models/index';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class Alarm_codesService {
    constructor(private http: HttpClient) {
    }

    getAllAlarm_codes() {
        return this.http.get<any>(AppConstants.SITE_URL + 'alarm_code/get_all_alarm_codes');
    }

    getAlarm_codes(alarm_code: Alarm_code) {
        return this.http.post<any>(AppConstants.SITE_URL + 'alarm_code/get_alarm_codes', alarm_code);
    }

    getAlarm_codeById(id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'alarm_code/get_alarm_codeById', { id: id });
    }

    saveAlarm_code(alarm_code) {
        return this.http.post<any>(AppConstants.SITE_URL + 'alarm_code/save_alarm_code', alarm_code);
    }

    deleteAlarm_code(id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'alarm_code/delete_alarm_code', { id: id });
    }



}



// WEBPACK FOOTER //
// /var/www/delios/delios-live/app/src/app/services/alarm_codes.service.ts